<button class="btn btn--more" tabindex="0" title="Sluit" modal-close-btn>
    <span>Sluit</span>
    <svg class="svg-icon svg-icon--xs"><use href="assets/icons-ui.svg#cross-closed"></use></svg>
</button>
<h2 modal-title>
    <span>Lager eigen risico</span>
</h2>
<div modal-content>
    <table class="table table--primary">
        <thead>
            <tr>
                <th></th>
                <th>Standaard eigen risico</th>
                <th>Hoger eigen risico (met lagere premie)</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>Eigen risico:</td>
                <td class="table__center">€&nbsp;0</td>
                <td class="table__center">€&nbsp;150</td>
            </tr>
            <tr>
                <td>Eigen risico stormschade:</td>
                <td class="table__center">€&nbsp;200</td>
                <td class="table__center">€&nbsp;200</td>
            </tr>
        </tbody>
    </table>
    <p>
        Het hogere eigen risico geldt voor de Inboedel- en Opstaldekkingen en de aanvullende dekkingen Compleet,
        Eigenaars- en Huurdersbelang. In ruil daarvoor betaalt minder premie.
    </p>
    <p>
        Het eigen risico voor de aanvullende Glasdekking is €&nbsp;0 en voor de Mobiele Elektronica dekking €&nbsp;50. Voor deze
        aanvullende dekkingen kunt u geen ander eigen risico kiezen.
    </p>
</div>
<div modal-actions alignment="end">
    <a href="#" title="Sluit" class="modal__close-bottom link-secondary" (click)="close()">
        <span>Sluit</span>
        <svg class="svg-icon svg-icon--xs"><use href="assets/icons-ui.svg#cross-closed"></use></svg>
    </a>
</div>
